//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import common from "@/assets/js/Common.js";
import api from "@/assets/js/Api.js";


import navbar from '@/components/ui/navbar';
import cardbox from '@/components/ui/cardbox';

export default {
    components: {
        cardbox,navbar
    },
    data(){
        return {

        }
    },
    methods:{


    },
    mounted(){


    },
}




// WEBPACK FOOTER //
// ./src/views/member/about.vue